import axios from '../../http'
import { handleGetRequestParams } from '../../common/js/util'

class biddingAcitvitives {
  //竞价活动列表
  getDBActivityList(biddingStatus, activityStatus, currentPage) {
    let url = `/api/db/activity/list?biddingStatus=${biddingStatus}&activityStatus=${activityStatus}&currentPage=${currentPage}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  //新增活动
  getDBActivityAdd(data) {
    let url = `/api/db/activity/save`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  //删除活动
  getDBActivityDelete(data) {
    let url = `/api/db/activity/del`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  //竞价商品列表
  getDBActivityDetail(id, currentPage, isPass) {
    let url = `/api/db/activity/goods/list?id=${id}&currentPage=${currentPage}&isPass=${isPass}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  //竞价商品审核
  getDBBiddingGoodsReview(data) {
    let url = `/api/db/activity/examine`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  //入围确认
  getDBActivityShortList(data) {
    let url = `/api/db/activity/update/weight`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data)
    })
  }
  //竞价商品的促销信息
  getDBBiddingGoodsInfo(id) {
    let url = `/api/db/activity/promotion?id=${id}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
  //竞价商品的促销信息
  getDBBiddingDetailBaseInfo(id) {
    let url = `/api/db/activity/info?id=${id}`
    return axios.get(url).then(res => {
      return Promise.resolve(res.data)
    })
  }
}

export default biddingAcitvitives